import { render } from "./ManageInstances.vue?vue&type=template&id=a8af7d90&scoped=true"
import script from "./ManageInstances.vue?vue&type=script&lang=js"
export * from "./ManageInstances.vue?vue&type=script&lang=js"

import "./ManageInstances.vue?vue&type=style&index=0&id=a8af7d90&scoped=true&lang=less"

import exportComponent from "/home/vinicius.valle/projetos/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8af7d90"]])

export default __exports__